module.exports = __webpack_public_path__ + "img/bg-car.581dfb74.jpg";